import "core-js/modules/es.array.slice.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "legacy-print-options",
    attrs: {
      "aria-labelledby": "legacy-options-title"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "legacy-options-grid"
  }, _vm._l(_vm.optionsList, function (option) {
    return _c('label', {
      key: option.key,
      class: ['legacy-option-row', {
        subordinate: option.subordinate,
        disabled: _vm.isDisabled(option)
      }],
      attrs: {
        "data-print-option": option.key
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(option.label))]), option.help ? _c('small', [_vm._v(_vm._s(option.help))]) : _vm._e()]), _c('b-form-checkbox', {
      attrs: {
        "switch": "",
        "checked": Boolean(_vm.value[option.key]),
        "disabled": _vm.isDisabled(option),
        "aria-label": option.label
      },
      on: {
        "change": function change($event) {
          return _vm.$emit('change', {
            key: option.key,
            enabled: $event
          });
        }
      }
    })], 1);
  }), 0), _vm.value.considerar_codigo_interno ? _c('div', {
    staticClass: "code-origin-note"
  }, [_c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._m(1)]) : _vm._e(), _c('div', {
    staticClass: "custom-print-text"
  }, [_c('label', {
    attrs: {
      "for": "etiqueta-texto-personalizado"
    }
  }, [_vm._v("Texto personalizado")]), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "etiqueta-texto-personalizado",
      "type": "text",
      "maxlength": "150",
      "placeholder": "Texto informado na hora da impressão"
    },
    domProps: {
      "value": _vm.customText
    },
    on: {
      "input": function input($event) {
        _vm.$emit('update:custom-text', $event.target.value.slice(0, 150));
      }
    }
  }), _c('small', [_vm._v(_vm._s(String(_vm.customText || "").length) + "/150 caracteres")])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "legacy-options-heading"
  }, [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Mesmo cenário da impressão real")]), _c('h6', {
    attrs: {
      "id": "legacy-options-title"
    }
  }, [_vm._v("Opções da tela Gerar etiquetas")]), _c('p', [_vm._v(" Marque aqui as mesmas opções que o usuário escolherá ao imprimir. A prévia e a impressão teste usarão exatamente esta combinação. ")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', [_vm._v(" O código interno substitui a referência e o EAN ao ser ligado. Com "), _c('strong', [_vm._v("somente numeração")]), _vm._v(", ele sai como texto, sem barras. ")]);
}];
export { render, staticRenderFns };